import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

const LegalFooter = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: 6,
        py: 3,
        px: 2,
        textAlign: 'center',
        borderTop: '1px solid #e0e0e0',
        color: 'text.secondary',
        fontSize: '14px',
      }}
    >
      <Typography variant="body2">
        <Link to="/terms">Terms</Link>
        {' | '}
        <Link to="/privacy">Privacy</Link>
        {' | '}
        <Link to="/refund-policy">Refunds</Link>
        {' | '}
        <Link to="/cancellation-policy">Cancellations</Link>
        {' | '}
        <Link to="/customer-agreement">Customer Agreement</Link>
        {' | '}
        <Link to="/carrier-agreement">Carrier Agreement</Link>
        {' | '}
        <span>Patent Pending</span>
      </Typography>

      <Typography variant="caption" display="block" sx={{ mt: 1 }}>
        © {new Date().getFullYear()} HaggleFreight. All rights reserved.
      </Typography>
    </Box>
  );
};

export default LegalFooter;